import React, { useMemo, useState } from 'react'

import { getPageMergetags, usePageVariables } from '@Components/hooks/usePageVariables'

import MergetagEditorFrame from './EditorFrame'

export default function PageVariablesEditorFrame({ children, ...props }) {
  const [enabled, setEnabled] = useState(false)
  const fields = usePageVariables(enabled)
  const mergetags = useMemo(() => getPageMergetags(fields), [fields])

  return <MergetagEditorFrame {...props} mergetags={mergetags} onOpen={() => setEnabled(true)}>
    {children}
  </MergetagEditorFrame>
}
